module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/5@2x_eb8282260810fd9537016ccb8fdeec17.png";